import { useMutation } from 'react-query'

import httpClient from 'services/http-client'

export const useGoogleTranslate = (lang: string) =>
  useMutation(async (input: string[]) => {
    return await httpClient.post(`${location.origin}/api/translate?lang=${lang}`, input)
  })
